import { modifier } from 'ember-modifier';
import type { SlSelect } from '@shoelace-style/shoelace';

interface MultipleSelectionSignature {
  Element: SlSelect;
  Args: {
    // Named: {};
    Positional: [string];
  };
}

/**
 * Sets the `value` property of a <sl-select> element on initialize.
 * i.e. : <sl-select multiple {{select-multiple-value-init this.selectedValues}}>
 *
 * Typically we can just use <sl-select value={{this.selectedValue}}>, but when
 * the sl-select allows for multiple selections, the element does not always
 * set the value correctly. This direct set via JS ensures that the value is
 * properly applied.
 *
 * The supplied argument should be a space-delimited string of selected values.
 */
const multipleSelectionModifier = modifier<MultipleSelectionSignature>(
  function multipleSelection(element, positional /*, named*/) {
    element.value = positional[0];
  }
);

export default multipleSelectionModifier;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'select-multiple-value-init': typeof multipleSelectionModifier;
  }
}
